{
  "Accessibility Menu": "Tilgængelighedsmenu",
  "Reset settings": "Nulstil indstillinger",
  "Close": "Luk",
  "Content Adjustments": "Justeringer af indhold",
  "Adjust Font Size": "Juster skriftstørrelse",
  "Highlight Title": "Fremhæv titel",
  "Highlight Links": "Fremhæv links",
  "Readable Font": "Læsbar skrifttype",
  "Color Adjustments": "Farvejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høj kontrast",
  "High Saturation": "Høj mætning",
  "Low Saturation": "Lav mætning",
  "Monochrome": "Monokrom",
  "Tools": "Værktøjer",
  "Reading Guide": "Læsevejledning",
  "Stop Animations": "Stop animationer",
  "Big Cursor": "Stor markør",
  "Increase Font Size": "Øg skriftstørrelse",
  "Decrease Font Size": "Mindsk skriftstørrelse",
  "Letter Spacing": "Bogstavafstand",
  "Line Height": "Linjehøjde",
  "Font Weight": "Skrifttypevægt",
  "Dyslexia Font": "Ordblinde-skrifttype",
  "Language": "Sprog",
  "Open Accessibility Menu": "Åbn tilgængelighedsmenu"
}